module.exports = __webpack_public_path__ + "img/4.60f50733.png";